import React, {PropsWithChildren} from "react";
import Head from "next/head";
import {
  Card,
  CardHeading,
  CardSubHeading
} from "styles/pages/web-checkout.styles";
import { UpdateUserProfileForm } from "components/web-checkout/user-profile-form/update-user-profile-form";
import { LoginBackground } from "components/web-checkout/login-background/login-background";
import { useRouter } from "next/router";

const UpdateUserCard: React.FC<PropsWithChildren> = ({ children, ...rest }) => {
  const childrenWithProps = React.Children.map(children, (child) => {
    if (React.isValidElement(child)) {
      return React.cloneElement(child, { ...rest });
    }
    return child;
  });
  return <Card>{childrenWithProps}</Card>;
};
const UpdateUserDetailsPage = (): JSX.Element => {
  const router = useRouter();

  return (
    <LoginBackground routerPath={router.pathname}>
      <Head>
        <title>CoLearn | Buat profil baru</title>
      </Head>

      <UpdateUserCard>
        <CardHeading>Ada sesi tanya-jawab gratis untukmu, nih 🎁</CardHeading>
        <CardSubHeading>Ambil undangannya sekarang!</CardSubHeading>

        <UpdateUserProfileForm />
      </UpdateUserCard>
    </LoginBackground>
  );
};

export default UpdateUserDetailsPage;

UpdateUserDetailsPage.requireAuth = true;
